// Carbon Filter Cartridge Products Data
export const carbonFilterCartridgeProducts = {
  'gac-granular-activated-carbon-filter': {
    id: 'gac-granular-activated-carbon-filter',
    title: 'GAC Granular Activated Carbon Filter Cartridge',
    name: 'GAC Granular Activated Carbon Filter Cartridge',
    shortDescription: 'Designed to reduce chlorine, bad taste, and odors effectively from drinking water.',
    description: 'Filled with granular activated carbon media to effectively reduce chlorine, bad taste, and odors from drinking water.',
    longDescription: 'Engineered to allow water to enter on one end and pass through the entire bed of carbon before exiting through the other end. An internal expansion pad is added to minimize channeling or bypass. A nominal 20 micron PP spun post filter and special sponge is incorporated to reduce carbon fines and other suspended particles.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/64d8f2fe9bb5bbfb9dfa438c9b7d5ae2.jpg',
    category: 'Carbon Filter Cartridge',
    features: [
      'Designed to fill with granular activated carbon media',
      'Reduce chlorine, bad taste and odors high effectively',
      'General reduction of bacteria from drinking water',
      'Engineered to allow water to enter on end and pass through the entire bed of carbon before exiting through the other end',
      'An internal expansion pad added to minimize channeling or bypass',
      'A nominal 20 micron PP spun post filter and special sponge is incorporated to reduce carbon fines and other suspended particles'
    ],
    applications: [
      'Drinking water'
    ],
    specifications: {
      'Filter media': 'Mineral GAC & Coconut shell GAC',
      'End cap/outer casing': 'Polystyrene',
      'Expansion pad': 'Polypropylene',
      'Post filter incorporated': '20 micron PP spun or sponge',
      'Gasket': 'Buna-N, Santoprene',
      'Netting': 'Polyethylene',
      'Outer diameter': '70mm, 115mm',
      'Inner diameter': '28mm',
      'Maximum operating temperature': '52℃'
    },
    technicalData: {
      'Ordering Guide': [
        {
          'Model GAC Style': 'GAC - 1',
          'Model GAC Material': 'M - Mineral AC',
          'Outer Diameter': 'S - 70mm',
          'Length (Inch)': '5:5"'
        },
        {
          'Model GAC Style': 'GAC - 2',
          'Model GAC Material': 'C - Coconut Shell AC',
          'Outer Diameter': 'B - 115mm',
          'Length (Inch)': '10:10"'
        },
        {
          'Model GAC Style': 'GAC - 3',
          'Model GAC Material': '',
          'Outer Diameter': '',
          'Length (Inch)': '20:20"'
        },
        {
          'Model GAC Style': 'GAC - BB',
          'Model GAC Material': '',
          'Outer Diameter': '',
          'Length (Inch)': ''
        }
      ]
    }
  },
  'cto-activated-carbon-block-filter-cartridge': {
    id: 'cto-activated-carbon-block-filter-cartridge',
    title: 'CTO Activated Carbon Block Filter Cartridge',
    name: 'CTO Activated Carbon Block Filter Cartridge',
    shortDescription: 'High absorbency carbon block filter for effective chlorine, taste, and odor reduction.',
    description: 'Provides high absorbency to effectively reduce chlorine, bad taste, and odors with a low pressure drop and no release of carbon fines.',
    longDescription: 'The CTO Activated Carbon Block Filter Cartridge is designed for high performance in various applications, offering superior purification by effectively removing unwanted tastes, odors, and chlorine.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/af6cc0d8a72c0bd78c63591624b20164.jpg',
    category: 'Carbon Filter Cartridge',
    features: [
      'High absorbency',
      'Reduce chlorine, bad taste and odors effectively',
      'Low pressure drop',
      'No carbon fines release'
    ],
    applications: [
      'Drinking water',
      'Plating liquid',
      'Food industry',
      'Industry water'
    ],
    specifications: {
      'Filter media': 'Mineral AC & Coconut shell AC',
      'End cap': 'PP',
      'Gasket': 'Buna-N',
      'Netting': 'polyethylene',
      'Outer diameter': '70mm, 115mm',
      'Inner diameter': '28mm',
      'Maximum operating temperature': '52℃',
      'Maximum differential pressure': '7 BAR at 20℃'
    },
    technicalData: {
      'Ordering Guide': [
        {
          'Model': 'CTO - M',
          'CTO Material': 'Mineral AC',
          'Outer Diameter': 'S - 70 mm',
          'Micron Rating': '05 : 5 µm',
          'Length (inch)': '5 : 5"'
        },
        {
          'Model': 'CTO - C',
          'CTO Material': 'Coconut Shell AC',
          'Outer Diameter': 'B - 115 mm',
          'Micron Rating': '10 : 10 µm',
          'Length (inch)': '10 : 10"'
        },
        {
          'Model': '',
          'CTO Material': '',
          'Outer Diameter': '',
          'Micron Rating': '...',
          'Length (inch)': '20 : 20"'
        },
        {
          'Model': '',
          'CTO Material': '',
          'Outer Diameter': '',
          'Micron Rating': '',
          'Length (inch)': '30 : 30"'
        },
        {
          'Model': '',
          'CTO Material': '',
          'Outer Diameter': '',
          'Micron Rating': '',
          'Length (inch)': '40 : 40"'
        }
      ]
    }
  },
  'acf-carbon-impregnated-cellulose-cartridge': {
    id: 'acf-carbon-impregnated-cellulose-cartridge',
    title: 'ACF Carbon Impregnated Cellulose Cartridge Filters',
    name: 'ACF Carbon Impregnated Cellulose Cartridge Filters',
    shortDescription: 'Composite filter combining depth filtration and activated carbon adsorption for effective purification.',
    description: 'The composite filter combines the performance of depth filtration and the adsorption of activated carbon fine. The outside deep fiber media can remove particles, and the activated carbon in filter cloth can adsorb the smell, odor, sediment, pigment, VOC and organic chemicals.',
    longDescription: 'The carbon impregnated cellulose filter cartridges are a composite that combines the performance of depth filtration and the adsorption of activated carbon fine. The outside deep fiber media can remove particles, and the activated carbon in filter cloth can adsorb the smell, odor, sediment, pigment, VOC and organic chemicals. The inside fiber filter can prevent carbon particles and fine pollutants from passing through, ensuring efficient quality and integrated filtration.',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/8f6bfdb8e8bf337e3d5a25015f118be2.jpg',
    category: 'Carbon Filter Cartridge',
    features: [
      'Economically priced',
      'Provides sediment filtration and adsorption finished in one time process',
      'High dirt-holding capacity',
      'Recommended for chlorinated water application',
      'Adsorption of organic substances'
    ],
    applications: [
      'Plating solution',
      'Solution of photograph developing',
      'Solution to remove oil and aromatic',
      'Oil and aromatic series in solution',
      'Removing dissociative chlorine and volatine organic compounds(VOC) in solution',
      'Drinking water and R.O pure water treatment',
      'Remove smell, odor, organic pigment',
      'Remove organic chemical'
    ],
    specifications: {
      'Filter media': 'AC Impregnated Cellulose',
      'End cap': 'Vinly Plastisol',
      'Netting': 'Polyethylene',
      'Core': 'Polypropylene',
      'Reinforcement Backing': 'Cellulose Polyester',
      'Gasket': 'Buna-N',
      'Outer diameter': '67mm',
      'Inner diameter': '28mm',
      'Maximum operating temperature': '52℃'
    },
    technicalData: {
      'Ordering Guide': [
        {
          'Model ACF Style': 'ACF - Activated Carbon Impregnated Cellulose',
          'Length (inch)': '5 : 5"'
        },
        {
          'Model ACF Style': '',
          'Length (inch)': '10 : 10"'
        },
        {
          'Model ACF Style': '',
          'Length (inch)': '20 : 20"'
        },
        {
          'Model ACF Style': '',
          'Length (inch)': '30 : 30"'
        },
        {
          'Model ACF Style': '',
          'Length (inch)': '40 : 40"'
        }
      ]
    }
  },
  't33-in-line-filter-cartridge': {
    id: 't33-in-line-filter-cartridge',
    title: 'T33 In-line Filter Cartridge',
    name: 'T33 In-line Filter Cartridge',
    category: 'Carbon Filter Cartridge',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/b377a703259cd9a22ec3a5e545d5bb1c.jpg',
    shortDescription: 'Post-carbon filter for taste and odor improvement in RO systems.',
    description: 'This T33 In-line filter is designed to remove unpleasant taste and odors as well as sediment to produce cleaner, purer water.',
    longDescription: 'The T33 In-line Filter Cartridge is a post-carbon filter designed to enhance the quality of drinking water. It effectively removes residual chlorine, taste, and odor, providing a polished and refreshing final product. It is commonly used as the last stage in reverse osmosis systems, water coolers, and icemakers.',
    features: [
        'Improves taste and odor of water',
        'Removes residual chlorine',
        'Ideal for post-RO system polishing',
        'Available in Mineral or Coconut activated carbon',
        'Long service life up to 2500 gallons'
    ],
    applications: [
        'Reverse Osmosis (RO) systems',
        'Water coolers',
        'Icemakers',
        'Refrigerators',
        'Drinking water fountains'
    ],
    specifications: {
      'Material': 'Mineral AC, Coconut AC',
      'Max. Water flow rate': '0.75 GPM',
      'Max. Temperature': '52℃',
      'Max. Working pressure': '125 psi'
    },
    technicalData: {
      'Models': [
        {
          'Model': 'T33-1',
          'Service Life': '1500 GAL'
        },
        {
          'Model': 'T33-2',
          'Service Life': '2500 GAL'
        }
      ]
    }
  }
};

export const carbonFilterCartridgeProductsList = [
  {
    id: 'gac-granular-activated-carbon-filter',
    name: 'GAC Granular Activated Carbon Filter Cartridge',
    category: 'Carbon Filter Cartridge',
    shortDescription: 'Designed to reduce chlorine, bad taste, and odors effectively from drinking water.',
    description: 'Filled with granular activated carbon media to effectively reduce chlorine, bad taste, and odors from drinking water.',
    features: [
      'Designed to fill with granular activated carbon media',
      'Reduce chlorine, bad taste and odors high effectively',
      'General reduction of bacteria from drinking water'
    ],
    applications: [
      'Drinking water'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/64d8f2fe9bb5bbfb9dfa438c9b7d5ae2.jpg'
  },
  {
    id: 'cto-activated-carbon-block-filter-cartridge',
    name: 'CTO Activated Carbon Block Filter Cartridge',
    category: 'Carbon Filter Cartridge',
    shortDescription: 'High absorbency carbon block filter for effective chlorine, taste, and odor reduction.',
    description: 'Provides high absorbency to effectively reduce chlorine, bad taste, and odors with a low pressure drop and no release of carbon fines.',
    features: [
      'High absorbency',
      'Reduce chlorine, bad taste and odors effectively',
      'Low pressure drop'
    ],
    applications: [
      'Drinking water',
      'Plating liquid',
      'Food industry'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/af6cc0d8a72c0bd78c63591624b20164.jpg'
  },
  {
    id: 'acf-carbon-impregnated-cellulose-cartridge',
    name: 'ACF Carbon Impregnated Cellulose Cartridge Filters',
    category: 'Carbon Filter Cartridge',
    shortDescription: 'Composite filter combining depth filtration and activated carbon adsorption for effective purification.',
    description: 'The composite filter combines the performance of depth filtration and the adsorption of activated carbon fine. The outside deep fiber media can remove particles, and the activated carbon in filter cloth can adsorb the smell, odor, sediment, pigment, VOC and organic chemicals.',
    features: [
      'Economically priced',
      'Provides sediment filtration and adsorption in one process',
      'High dirt-holding capacity'
    ],
    applications: [
      'Plating solution',
      'Drinking water and R.O pure water treatment',
      'Remove smell, odor, organic pigment'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/8f6bfdb8e8bf337e3d5a25015f118be2.jpg'
  },
  {
    id: 't33-in-line-filter-cartridge',
    name: 'T33 In-line Filter Cartridge',
    category: 'Carbon Filter Cartridge',
    shortDescription: 'Post-carbon filter for taste and odor improvement in RO systems.',
    description: 'This T33 In-line filter is designed to remove unpleasant taste and odors as well as sediment to produce cleaner, purer water.',
    features: [
        'Improves taste and odor of water',
        'Removes residual chlorine',
        'Ideal for post-RO system polishing'
    ],
    applications: [
        'Reverse Osmosis (RO) systems',
        'Water coolers',
        'Icemakers'
    ],
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/b377a703259cd9a22ec3a5e545d5bb1c.jpg'
  }
];

export default carbonFilterCartridgeProducts;